import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useRef } from 'react';
import { observer, Observer } from 'mobx-react';
import { Item, Content, Info, Label, Editor } from '../Item';
import { Dropdown, DropdownItem, DropdownItemIcon } from '../../../../components/Dropdown';
import Icon from '../../../../components/Icon';
import { answerToString } from '../../../../utils/questionUtil';
import styles from './Select.m.sass';
import truncate from 'lodash/truncate';
var Select = function Select(props) {
  var checkout = props.checkout;
  return /*#__PURE__*/React.createElement(Item, {
    checkout: checkout,
    title: props.question.description
  }, /*#__PURE__*/React.createElement(Content, {
    checkout: checkout
  }, /*#__PURE__*/React.createElement(Info, {
    checkout: checkout
  }, /*#__PURE__*/React.createElement(Label, {
    checkout: checkout
  }, props.question.question)), /*#__PURE__*/React.createElement(Editor, {
    checkout: checkout
  }, props.readOnly ? /*#__PURE__*/React.createElement("div", {
    className: styles.response
  }, answerToString(props.question, props.answer)) : /*#__PURE__*/React.createElement(SelectEditor, props))));
};
export default observer(Select);
var SelectEditor = function SelectEditor(_ref) {
  var question = _ref.question,
    answer = _ref.answer,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    onUpdate = _ref.onUpdate;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDropdownOpen = _useState2[0],
    setIsDropdownOpen = _useState2[1];
  var didCallChange = useRef(false);
  var closeDropdown = function closeDropdown() {
    setIsDropdownOpen(false);
    if (didCallChange.current) {
      onUpdate();
      didCallChange.current = false;
    }
  };
  var onDropdownButtonClick = function onDropdownButtonClick() {
    if (isDropdownOpen) {
      closeDropdown();
    } else {
      setIsDropdownOpen(true);
    }
  };
  return /*#__PURE__*/React.createElement(Observer, null, function () {
    answer = answer || (question.multi ? [] : '');
    return /*#__PURE__*/React.createElement(Dropdown, {
      position: "right",
      disabled: disabled,
      isOpen: isDropdownOpen,
      className: styles.root,
      onButtonClick: onDropdownButtonClick,
      onRequestClose: closeDropdown,
      persist: true,
      button: /*#__PURE__*/React.createElement("button", {
        className: styles.button,
        disabled: disabled
      }, renderButtonText(question, answer), /*#__PURE__*/React.createElement("span", {
        className: styles.icon
      }, /*#__PURE__*/React.createElement(Icon, {
        size: 18,
        material: true,
        name: "keyboard arrow down"
      })))
    }, question.options.map(function (option) {
      var active = question.multi ? answer.indexOf(option.id) > -1 : option.id === answer;
      return /*#__PURE__*/React.createElement(DropdownItem, {
        key: option.id,
        onClick: function onClick() {
          return change(option.id);
        },
        disabled: disabled,
        title: option.text
      }, /*#__PURE__*/React.createElement(DropdownItemIcon, {
        material: true,
        name: active ? question.multi ? 'check box' : 'radio button checked' : question.multi ? 'check box outline blank' : 'radio button unchecked'
      }), truncate(option.text, {
        length: 65
      }));
    }));
  });
  function change(optionId) {
    if (disabled) {
      return;
    }
    didCallChange.current = true;
    if (!question.multi) {
      onChange(optionId);
      closeDropdown();
    } else {
      var isSelected = answer.some(function (v) {
        return v === optionId;
      });
      var newSelection = isSelected ? answer.filter(function (v) {
        return v !== optionId;
      }) : [optionId].concat(_toConsumableArray(answer));
      onChange(newSelection);
    }
  }
};
function renderButtonText(question, answer) {
  if (!question.multi) {
    if (!answer) {
      return '(select)';
    }
    var text = getOptionText(question, answer);
    return /*#__PURE__*/React.createElement("span", {
      className: styles.selection,
      title: text
    }, truncate(text, {
      length: 30
    }));
  }
  if (answer.length === 0) {
    return '(select)';
  }
  var nodes = getButtonNodes(question, answer);
  return /*#__PURE__*/React.createElement("span", null, nodes.visible.join(', '), nodes.remaining > 0 && /*#__PURE__*/React.createElement("span", {
    className: styles.more
  }, " and ", nodes.remaining, " more"));
}

/**
 * For multi selects, display only a certain amount of items based on their text length.
 * @param {*} question
 * @param {*} answers
 */
function getButtonNodes(question, answers) {
  var maxCharacters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 28;
  var remaining = answers.length;
  var visible = [];
  var used = 0;
  for (var i = 0; i < answers.length; i++) {
    var answer = answers[i];
    var text = getOptionText(question, answer);
    var nextUsed = used + text.length;
    if (nextUsed >= maxCharacters && i > 0) {
      return {
        visible: visible,
        remaining: remaining
      };
    }
    used = nextUsed;
    remaining--;
    visible.push(text);
  }
  return {
    visible: visible,
    remaining: remaining
  };
}
function getOptionText(question, optionId) {
  var option = question.options.find(function (o) {
    return o.id === optionId;
  });
  return option ? option.text : optionId;
}
//# sourceMappingURL=index.js.map
